var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "cont-tit" }, [
      _c("h6"),
      _c("div", { staticClass: "tbl-top-etc" }, [
        _vm._v(_vm._s(/*(연이율, 세전, 단위 : %)*/ _vm.$t("MDEP-01-02-03-07")))
      ])
    ]),
    _c("table", { staticClass: "table -type02" }, [
      _c("thead", [
        _c("tr", [
          _c("th", { attrs: { scope: "col" } }, [
            _vm._v(_vm._s(/*기간*/ _vm.$t("MDEP-01-02-03-06")))
          ]),
          _c("th", { attrs: { scope: "col" } }, [_vm._v("USD")]),
          _c("th", { attrs: { scope: "col" } }, [_vm._v("KHR")]),
          _c("th", { attrs: { scope: "col" } }, [
            _vm._v(_vm._s(/*금리구분*/ _vm.$t("MDEP-01-02-03-15")))
          ])
        ])
      ]),
      _c("tbody", [
        _c("tr", [
          _c("td", [_vm._v("-")]),
          _c("td", [_vm._v("0.50")]),
          _c("td", [_vm._v("0.70")]),
          _c("td", [_vm._v(_vm._s(/*확정금리*/ _vm.$t("MDEP-01-02-03-16")))])
        ])
      ])
    ]),
    _c("div", { staticClass: "info info-etc" }, [
      _vm._v(
        "· " +
          _vm._s(/*영업점 내점상담 후, 금리 결정*/ _vm.$t("MDEP-01-02-03-17"))
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }